import React from 'react';
import AdminSearchTable from '../Admin/AdminSearchTable'

const SuppContractHistorySection = ({ model }) => {
    const claims = model?.suppContractHistory || [];

    const columns = [
        { label: 'Suffix', accessor: 'suffix' },
        { label: 'Entry Date', accessor: 'entryDate' },
        { label: 'Amount', accessor: 'amountDisplay' },
        { label: 'State Withheld', accessor: 'stateWH' },
        { label: 'Federal Withheld', accessor: 'fitWH' },
        { label: 'Net Check Amount', accessor: 'netCheckAmount' },
    ];

    if (claims.length === 0) {
        return (
            <div className="container container-section" id="supp-contract-history-container">
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <div className="flex-container">
                            <h5>No payments Found</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container container-section" id="supp-contract-history-container">
            <AdminSearchTable columns={columns} data={claims} />
        </div>
    );
};

export default SuppContractHistorySection;
